
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Home() {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Redirect logged-in users to create listing page when they click "Start Selling"
  const handleStartSelling = (e) => {
    e.preventDefault();
    if (isAuthenticated && user) {
      navigate('/create-listing');
    } else {
      navigate('/register');
    }
  };

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">Welcome to Classifieds.com</h1>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Buy and sell items with confidence. A modern, secure platform for buying and selling in your community.
          </p>
          <div className="flex justify-center space-x-4">
            <Link to="/listings" className="bg-white text-blue-800 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors shadow-lg">
              Browse Listings
            </Link>
            <button 
              onClick={handleStartSelling}
              className="bg-secondary text-white px-8 py-3 rounded-lg font-semibold hover:bg-amber-600 transition-colors shadow-lg"
            >
              Start Selling
            </button>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-800 mb-12 text-center">Why Choose Us?</h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="text-secondary text-4xl mb-4">🔒</div>
              <h3 className="text-xl font-semibold mb-2">Secure Platform</h3>
              <p className="text-gray-600">Your privacy is protected. Communicate safely without exposing your email address.</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="text-secondary text-4xl mb-4">⚡</div>
              <h3 className="text-xl font-semibold mb-2">Fast & Easy</h3>
              <p className="text-gray-600">List items in minutes with our intuitive interface and photo upload system.</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="text-secondary text-4xl mb-4">💬</div>
              <h3 className="text-xl font-semibold mb-2">Direct Messaging</h3>
              <p className="text-gray-600">Chat directly with buyers and sellers through our secure messaging system.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
